export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            投稿合作
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8">
            如有视频平台合作、内容投稿或建议反馈，欢迎通过以下方式联系我们
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-600">平台收录与广告投放</p>
            </div>
            <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-send-plane-line text-xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-600">推荐优质视频资源</p>
            </div>
            <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-secondary-200 transition-all duration-300">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                <i className="ri-feedback-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-600">帮助我们做得更好</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-foreground-600">
            <div className="flex items-center gap-2">
              <i className="ri-mail-open-line text-primary-500"></i>
              <span>contact@juzivideo.com</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-customer-service-line text-accent-500"></i>
              <span>在线客服：工作日 9:00-18:00</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}